export default {
  'byb-step-3': {
    contactAffiliateQuestion:
      'Please select “Yes” if the recruit was an agent with one of the following affiliates or prior companies: A Primerica company in the US or Canada including Primerica Life Insurance Company of Canada, PFSL Investments Canada Ltd., Primerica Financial Services Ltd, Primerica Client Services Inc., A.L. Williams, MILICO, National Benefit Life, or Primerica Financial Services of New York?',
  },
};
